import { FormEvent } from "react";
import { Search } from "react-feather";
import logo from "@/assets/images/logo-claro.png";
import { linkCadastro } from "@/lib/constants";

// Cabeçalho do rastreio: o logo do betracking no centro (Murilo, 20/10/2026),
// a busca de outro código em cima (é o primeiro lugar onde se procura) e o
// convite pra conhecer a beuni, que leva pro cadastro da plataforma.
//  - computador: busca | logo | convite, numa linha;
//  - celular: logo à esquerda e convite à direita, a busca inteira embaixo.
export default function Cabecalho({ codigo, onBuscar }: { codigo?: string; onBuscar?: (codigo: string) => void }) {
  const buscar = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const valor = String(new FormData(e.currentTarget).get("codigo") ?? "").trim();
    if (valor) onBuscar?.(valor);
  };

  return (
    <header className="bg-[#3F2021]">
      <div className="mx-auto grid max-w-7xl grid-cols-[1fr_auto_1fr] items-center gap-x-3 gap-y-3 px-4 py-3 sm:px-6 lg:py-4">
        {/* Na página inicial a busca é o destaque da página, não fica no menu. */}
        {onBuscar && (
        <form onSubmit={buscar} className="col-span-3 row-start-2 lg:col-span-1 lg:row-start-1" role="search">
          <label htmlFor="codigo" className="sr-only">
            Código de rastreio
          </label>
          <div className="flex h-11 items-center rounded-full bg-white pl-4 focus-within:ring-2 focus-within:ring-[#FFB990] lg:max-w-sm">
            <Search size={17} className="shrink-0 text-[#6b5556]" />
            <input
              id="codigo"
              name="codigo"
              key={codigo}
              defaultValue={codigo}
              placeholder="Rastrear outro código"
              autoComplete="off"
              autoCapitalize="characters"
              spellCheck={false}
              className="min-w-0 flex-1 bg-transparent px-2.5 text-[15px] text-[#3F2021] outline-none placeholder:text-[#8a7778]"
            />
            <button type="submit" className="mr-1 h-9 rounded-full bg-[#3F2021] px-4 text-sm font-semibold text-white hover:bg-[#2c1617]">
              Rastrear
            </button>
          </div>
        </form>
        )}

        <a href="/" aria-label="betracking" className="col-span-2 col-start-1 row-start-1 justify-self-start sm:col-span-1 sm:col-start-2 sm:justify-self-center">
          <img src={logo} alt="betracking" className="h-7 sm:h-9" />
        </a>

        <a
          href={linkCadastro("cabecalho")}
          target="_blank"
          rel="noreferrer"
          className="col-start-3 row-start-1 inline-flex h-9 items-center justify-self-end whitespace-nowrap rounded-full bg-[#FF5600] px-4 text-[13px] font-bold text-white transition hover:bg-[#DC4405] sm:h-11 sm:px-5 sm:text-sm"
        >
          <span className="hidden sm:inline">Quero conhecer a beuni</span>
          <span className="sm:hidden">Conhecer a beuni</span>
        </a>
      </div>
    </header>
  );
}
